import candidateApi from './api';

export const getResumes = async () => {
  try {
    const response = await candidateApi.get('/resume');
    return response.data;
  } catch (error) {
    console.error('Error fetching resumes:', error);
    throw error;
  }
};

export const uploadResume = async (resumeFile) => {
  try {
    const formData = new FormData();
    formData.append('resume', resumeFile);

    const response = await candidateApi.post('/resume/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error uploading resume:', error);
    throw error;
  }
};

export const deleteResume = async (id) => {
  try {
    const response = await candidateApi.delete(`/resume/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting resume:', error);
    throw error;
  }
};

export const setPrimaryResume = async (id) => {
  try {
    const response = await candidateApi.patch(`/resume/${id}/set-primary`);
    return response.data;
  } catch (error) {
    console.error('Error setting primary resume:', error);
    throw error;
  }
};